import { render, staticRenderFns } from "./generate-assets.vue?vue&type=template&id=3c68910e&"
import script from "./generate-assets.vue?vue&type=script&lang=js&"
export * from "./generate-assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports